<div class="container">
  <app-agricola-toast
    [message]="toastMessage"
    [type]="toastType"
    [show]="showToast"
    (close)="hideToast()">
  </app-agricola-toast>

  <div class="card premium-card">
    <app-agricola-stepper
      [steps]="steps"
      [currentStep]="selectedIndex"
      (backClick)="goBack()"
      (stepClick)="goToStep($event)">
    </app-agricola-stepper>

    <h2>{{ stepTitle }}</h2>

    <div class="insured-block">
      <p class="assistance-intro">{{ stepDescription }}</p>

      <div class="assistance-products-compact">
        <button
          type="button"
          class="assistance-chip"
          *ngFor="let product of selectableProducts; trackBy: trackByProductId"
          [class.is-active]="isActiveAssistanceProduct(product)"
          (click)="onSelectAssistanceProduct(product)">
          <span class="assistance-chip-icon">
            <img src="assets/agricola/persona.svg" alt="" aria-hidden="true" />
          </span>
          <span class="assistance-chip-label">{{ product.product_name }}</span>
          <span class="assistance-chip-check" *ngIf="isActiveAssistanceProduct(product)" aria-hidden="true">✓</span>
        </button>
      </div>

      <div class="premium-layout" [formGroup]="premiumData">
        <div class="premium-inputs">
          <app-sis-select
            *ngIf="showAgeRange"
            label="Selecciona el rango de edad"
            [options]="ageRangeOptions"
            [loading]="loadingPlans"
            [loadedKey]="plansLoadedKey"
            loadedMessage="Catálogo de rangos cargado"
            [loadFailed]="plansLoadFailed"
            (retryLoad)="retryLoadPlans()"

            [helper]="loadingPlans ? 'Cargando rangos...' : ''"
            formControlName="ageRange">
          </app-sis-select>

          <app-sis-select
            label="*Opción plan"
            placeholder="Opción plan"
            [options]="planOptions"
            [loading]="loadingPlans"
            [loadedKey]="plansLoadedKey"
            loadedMessage="Catálogo de planes cargado"
            [loadFailed]="plansLoadFailed"

            [helper]="loadingPlans ? 'Cargando planes...' : ''"
            [error]="premiumData.get('planOption')?.invalid && premiumData.get('planOption')?.touched ? 'Escoge una opción de plan' : ''"
            formControlName="planOption">
          </app-sis-select>
        </div>

        <!-- Comparación de planes disponibles para el producto seleccionado -->
        <div class="comparison-grid" [class.loading-table]="loadingPlans" [style.grid-template-columns]="tableGridColumns">
          <div class="table-loading" *ngIf="loadingPlans">Cargando planes...</div>
          <article
            class="plan-column plan-column--compact"
            *ngFor="let plan of plans"
            [class.is-active]="selectedPlan?.plan === plan.plan">
            <h3>{{ plan.description }}</h3>
            <span>Prima</span>
            <strong>{{ getPlanPrice(plan) }}</strong>
          </article>
        </div>
      </div>
    </div>
  </div>

  <div class="card coverages-card">
    <div class="section-heading">
      <div>
        <h2>Coberturas</h2>
        <p>Coberturas incluidas en el plan</p>
      </div>
      <app-sis-button *ngIf="showCondicionado" variant="secondary" [disabled]="loadingCondicionado" (pressed)="openCondicionado()">{{ loadingCondicionado ? 'Abriendo...' : 'Ver condicionado' }}</app-sis-button>
    </div>

    <div class="insured-block">
      <div class="coverages-grid">
        <div class="coverage-loading" *ngIf="loadingPlans">Cargando coberturas...</div>
        <div class="coverage-item" *ngFor="let coverage of (coverageItems | slice:0:12)">
          <app-sis-checkbox class="coverage-check" [checked]="true" [disabled]="true" [ariaLabel]="coverage.label + ' incluido'"></app-sis-checkbox>
          <span>{{ coverage.label }}</span>
          <strong *ngIf="coverage.value">{{ coverage.value }}</strong>
        </div>
      </div>
    </div>
  </div>

  <div class="card addons-card" *ngIf="isAssistance">
    <div class="section-heading section-heading--center">
      <div>
        <h2>Coberturas Adicionales</h2>
        <p>Selecciona coberturas adicionales para ofrecer al cliente</p>
      </div>
    </div>

    <div class="insured-block">
      <div class="addon-loading" *ngIf="loadingAddOns">Cargando coberturas adicionales...</div>
      <div class="addon-error" *ngIf="addOnsLoadFailed">
        <span>No fue posible cargar las coberturas adicionales.</span>
        <app-sis-button variant="secondary" (pressed)="retryLoadAddOns()">Reintentar</app-sis-button>
      </div>

      <div class="addons-grid" *ngIf="!loadingAddOns && !addOnsLoadFailed">
        <article
          class="addon-card"
          *ngFor="let addOn of addOns"
          [class.is-selected]="isAddOnSelected(addOn)"
          (click)="onToggleAddOn(getAddOnId(addOn))">
          <app-sis-checkbox
            class="addon-card-check"
            [checked]="isAddOnSelected(addOn)"
            [ariaLabel]="addOn.plan_name"
            (click)="$event.stopPropagation()"
            (change)="onToggleAddOn(getAddOnId(addOn))">
          </app-sis-checkbox>

          <div class="addon-card-body">
            <div class="addon-card-header">
              <h3>{{ addOn.plan_name }}</h3>
              <strong>{{ addOnPriceLabel(addOn) }}</strong>
            </div>

            <ul class="addon-coverages" *ngIf="addOn.coverages?.length">
              <li *ngFor="let coverage of (addOn.coverages | slice:0:5)">
                {{ coverage.detail || coverage.info }}
              </li>
            </ul>
          </div>
        </article>

        <div class="addon-empty" *ngIf="!addOns.length">
          No hay coberturas adicionales disponibles para el plan seleccionado.
        </div>
      </div>
    </div>
  </div>

  <!-- Prima final y acciones viven fuera de la tarjeta de add-ons para que se
       rendericen igual en asistencias y en seguros. -->
  <div class="card">
    <div class="insured-block">
      <div class="final-premium">
        <span>Prima final calculada</span>
        <strong>{{ finalPremiumDisplay }}</strong>
      </div>
    </div>

    <div class="actions">
      <app-sis-button variant="secondary" (pressed)="goBack()">Cancelar</app-sis-button>
      <app-sis-button [disabled]="loadingPlans || loadingAddOns" (pressed)="onContinueClick()">Continuar</app-sis-button>
    </div>
  </div>
</div>
